export default "__VITE_ASSET__4Kni$IMu__";